"use strict";

exports.__esModule = true;
exports["default"] = SocialInstagram;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SocialInstagram(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M485.5 1h-459C12.4 1 1 12.4 1 26.5v459C1 499.6 12.4 511 26.5 511h459c14.1 0 25.5-11.4 25.5-25.5v-459C511 12.4 499.6 1 485.5 1zM255.6 157.6c54.1 0 97.9 43.8 97.9 97.9s-43.9 97.9-97.9 97.9c-54.1 0-97.9-43.9-97.9-97.9-.1-54 43.8-97.9 97.9-97.9zm195.8 274.2c0 10.8-8.8 19.6-19.6 19.6H79.3c-10.8 0-19.6-8.8-19.6-19.6V216.4H104c-3.2 12.5-5.1 25.6-5.1 39.2 0 86.5 70.1 156.7 156.6 156.7s156.7-70.1 156.7-156.7c0-13.5-1.9-26.6-5.1-39.2h44.3v215.4zm0-293.7c0 10.8-8.8 19.6-19.6 19.6h-58.7c-10.8 0-19.6-8.8-19.6-19.6V79.3c0-10.8 8.7-19.6 19.6-19.6h58.7c10.8 0 19.6 8.8 19.6 19.6v58.8z",
    fill: "#939496"
  }));
}